import React from 'react';

const Markets = () => {
  return (
    <section className="markets" id="markets">
      <div className="container">
        <div className="section-header light reveal">
          <span className="label">Export Markets</span>
          <h2>Global Reach, <span className="highlight">Local Trust</span></h2>
          <p>Supplying genuine American automotive parts to businesses across six continents.</p>
        </div>

        <div className="markets-map reveal">
          <svg viewBox="0 0 800 450" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="grid" width="30" height="30" patternUnits="userSpaceOnUse">
                <path d="M 30 0 L 0 0 0 30" fill="none" stroke="rgba(255,255,255,0.025)" strokeWidth="1" />
              </pattern>
              <radialGradient id="hubGlow" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#C9A227" stopOpacity="0.3" />
                <stop offset="100%" stopColor="#C9A227" stopOpacity="0" />
              </radialGradient>
            </defs>

            {/* Grid background */}
            <rect width="800" height="450" fill="url(#grid)" rx="16" />

            {/* Subtle globe rings */}
            <circle cx="400" cy="225" r="180" stroke="rgba(255,255,255,0.03)" strokeWidth="1" strokeDasharray="4 8" />
            <circle cx="400" cy="225" r="120" stroke="rgba(255,255,255,0.02)" strokeWidth="1" strokeDasharray="2 6" />

            {/* CENTRAL HUB: Dubai */}
            <circle cx="400" cy="240" r="60" fill="url(#hubGlow)" />
            <circle cx="400" cy="240" r="12" fill="#C9A227" />
            <circle cx="400" cy="240" r="6" fill="#F5D742" />
            {/* Pulsing ring around Dubai */}
            <circle cx="400" cy="240" r="6" fill="none" stroke="#C9A227" strokeWidth="2" opacity="0.6">
              <animate attributeName="r" values="6;30;6" dur="3s" repeatCount="indefinite" />
              <animate attributeName="opacity" values="0.8;0;0.8" dur="3s" repeatCount="indefinite" />
            </circle>

            {/* EXPORT ROUTES (Animated Dashed Lines) */}
            {/* To USA */}
            <path d="M 390 230 Q 250 120 140 160" className="route-path gold" />
            {/* To Europe */}
            <path d="M 395 235 Q 370 100 330 110" className="route-path gold" style={{ animationDelay: '0.5s' }} />
            {/* To Asia */}
            <path d="M 410 235 Q 540 120 620 160" className="route-path blue" style={{ animationDelay: '1s' }} />
            {/* To Africa */}
            <path d="M 395 250 Q 380 320 340 340" className="route-path gold" style={{ animationDelay: '1.5s' }} />
            {/* To South America */}
            <path d="M 390 245 Q 280 350 220 370" className="route-path blue" style={{ animationDelay: '2s' }} />
            {/* To Australia */}
            <path d="M 405 245 Q 560 360 660 380" className="route-path gold" style={{ animationDelay: '2.5s' }} />

            {/* DESTINATION NODES */}
            {/* USA */}
            <circle cx="140" cy="160" r="18" fill="rgba(201,162,39,0.08)" className="glow-ring" />
            <circle cx="140" cy="160" r="6" fill="#C9A227" />
            <circle cx="140" cy="160" r="6" fill="#C9A227" className="pulse-dot" />
            <text x="140" y="148" textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="9" fontFamily="Poppins, sans-serif" fontWeight="500">USA</text>

            {/* Europe */}
            <circle cx="330" cy="110" r="18" fill="rgba(201,162,39,0.08)" className="glow-ring" />
            <circle cx="330" cy="110" r="6" fill="#C9A227" />
            <circle cx="330" cy="110" r="6" fill="#C9A227" className="pulse-dot delay-1" />
            <text x="330" y="98" textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="9" fontFamily="Poppins, sans-serif" fontWeight="500">EUROPE</text>

            {/* Asia */}
            <circle cx="620" cy="160" r="18" fill="rgba(14,77,164,0.08)" className="glow-ring" />
            <circle cx="620" cy="160" r="6" fill="#0E4DA4" />
            <circle cx="620" cy="160" r="6" fill="#0E4DA4" className="pulse-dot delay-2" />
            <text x="620" y="148" textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="9" fontFamily="Poppins, sans-serif" fontWeight="500">ASIA</text>

            {/* Africa */}
            <circle cx="340" cy="340" r="18" fill="rgba(201,162,39,0.08)" className="glow-ring" />
            <circle cx="340" cy="340" r="6" fill="#C9A227" />
            <circle cx="340" cy="340" r="6" fill="#C9A227" className="pulse-dot delay-3" />
            <text x="340" y="328" textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="9" fontFamily="Poppins, sans-serif" fontWeight="500">AFRICA</text>

            {/* South America */}
            <circle cx="220" cy="370" r="18" fill="rgba(14,77,164,0.08)" className="glow-ring" />
            <circle cx="220" cy="370" r="6" fill="#0E4DA4" />
            <circle cx="220" cy="370" r="6" fill="#0E4DA4" className="pulse-dot delay-4" />
            <text x="220" y="358" textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="9" fontFamily="Poppins, sans-serif" fontWeight="500">S. AMERICA</text>

            {/* Australia */}
            <circle cx="660" cy="380" r="18" fill="rgba(201,162,39,0.08)" className="glow-ring" />
            <circle cx="660" cy="380" r="6" fill="#C9A227" />
            <circle cx="660" cy="380" r="6" fill="#C9A227" className="pulse-dot delay-5" />
            <text x="660" y="368" textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="9" fontFamily="Poppins, sans-serif" fontWeight="500">AUSTRALIA</text>

            {/* Central Label */}
            <text x="400" y="278" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="10" fontFamily="Poppins, sans-serif" letterSpacing="2" fontWeight="500">DUBAI · UAE</text>
          </svg>
        </div>

        <div className="markets-tags reveal">
          <span className="markets-tag">GCC</span>
          <span className="markets-tag">Middle East</span>
          <span className="markets-tag">Asia</span>
          <span className="markets-tag">Europe</span>
          <span className="markets-tag">Africa</span>
          <span className="markets-tag">North America</span>
          <span className="markets-tag">South America</span>
          <span className="markets-tag">Worldwide</span>
        </div>
      </div>
    </section>
  );
};

export default Markets;